import { useRecalculateResults } from 'Features/Results/Results.hooks.ts';
import { useUpdateAssessmentLockMutation } from 'models/index.ts';
import { useParams } from 'react-router-dom';

export const useLockAssessment = () => {
  const { cAssessmentId } = useParams<{ cAssessmentId: string }>();
  const [
    updateAssessmentLock,
    { loading: updateAssessmentLockLoading, error: updateAssessmentLockError },
  ] = useUpdateAssessmentLockMutation();

  const {
    recalculate,
    loading: recalculateLoading,
    error: recalculateError,
  } = useRecalculateResults(cAssessmentId);

  const lockAssessment = async () => {
    try {
      await updateAssessmentLock({
        variables: {
          companyAssessmentId: cAssessmentId,
          isLocked: true,
        },
      });
      await recalculate();
    } catch (e) {
      console.error(e);
    }
  };
  return {
    lockAssessment,
    loading: updateAssessmentLockLoading || recalculateLoading,
    error: updateAssessmentLockError || recalculateError,
  };
};
